<template>
  <v-main :style="{ backgroundImage: `url(${require('@/assets/BG_01.jpg')})`}" style="background-repeat: repeat;background-size: 180%;padding-bottom: 10%;">
    <div
      style="
        display: flex;
        align-items: center;
        height: 80px;
        color: white;
        margin-bottom: -20px;
        padding-left: 5px;
      "
      class="ml-3"
    >
      <!-- ซ้าย: โลโก้ -->
      <div>
        <v-img
          :src="require('@/assets/Lable_01.png')"
          width="290"
          height="70"
          class="d-inline-block"
        >
          <div
            class="d-flex justify-center align-center"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; color: white; font-weight: bold;font-size: 24px;"
          >
          {{ this.languageSelect.value === 0 ? "บัตรคิว " : "Queue Ticket " }} POP MART CAFE
          </div>
        </v-img>
      </div>

      <!-- ขวา: เมนูภาษา -->
      <div style="margin-left: auto; padding-right: 10px;">
        <v-menu
          v-model="menu"
          offset-y
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              class="ma-2"
              :style="`background-color:white;color: #2e263d; font-size: 20px;border-radius: 20px !important;`"
              dark
              label
              style="cursor: pointer;"
            >
              <v-avatar left>
                <v-img :src="languageSelect.flag" />
              </v-avatar>
              {{ languageSelect.text }}
              <v-icon right style="color: #2e263d;">mdi-menu-down</v-icon>
            </v-chip>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in languageOptions"
              :key="index"
              @click="onLanguageSelect(item)"
            >
              <v-list-item-avatar>
                <v-img :src="item.flag" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-card class="ma-6" :color="DarkModeBackground"
      :style="'background: white;' + ';margin: 20px !important;overflow-x:hidden;overflow-y: auto;max-height: 83vh;'">
      <v-sheet v-if="loading">
        <div class="text-center mt-6" :style="'background-color:white;'">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </v-sheet>
      <v-sheet v-else class="pt-3 pb-3"
        :style="'background-color:white'">
        <div>
          <div class="pa-3" >
            <v-row >
              <v-col cols="12" class="text-center mt-1">
                <h4  class="text-center" style="font-size: 32px;">{{ this.languageSelect.value === 0 ?
              "หมายเลขคิวของคุณ" : "Your Number" }}</h4>

              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class=" pt-0 mb-3">
                <div class="d-flex justify-center ">
                  <v-card
                  v-for="(char, index) in this.dataBookingData.queueNumber"
                    :key="index"
                    class="mx-1 text-h5 d-flex align-center justify-center gradient-card font-semi"
                    width="52"
                    height="70"
                    elevation="3"
                    rounded="lg"
                    style="color:white;background: #ffadcd;"
                  >
                    <h1 class="myqueue">{{ char }}</h1>
                  </v-card>
                </div>
              </v-col>
            </v-row>
            <!-- <v-row style="background-color:#FFE5EE">
              <v-col cols="6">
                <div class="text-left font-weight-bold2 ml-10">
                  {{ this.languageSelect.value === 0 ? "สาขา" : "Branch" }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-cond">
                  {{ this.languageSelect.value === 0 ? 'POP MART CAFE' : 'POP MART CAFE'}}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-bold2 ml-10">
                  {{ this.languageSelect.value === 0 ? "จำนวนที่นั่ง" : "SeatCount"}}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-cond">
                  {{ this.languageSelect.value === 0 ? this.dataBookingData.seatCount : this.dataBookingData.seatCount}} {{ this.languageSelect.value === 0 ? "ที่นั่ง" : "Seats"}}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-bold2 ml-10">
                  {{ this.languageSelect.value === 0 ? "โต๊ะ" : "Table"
                    }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-cond">
                  {{ this.languageSelect.value === 0 ? this.dataBookingData.tables : this.dataBookingData.tables}}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-bold2 ml-10">
                  {{ this.languageSelect.value === 0 ? "รอบเวลา" : "TimeSlot"
                    }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-left font-weight-cond">
                  {{ this.languageSelect.value === 0 ? this.dataBookingData.timeSlot : this.dataBookingData.timeSlot}}
                </div>
              </v-col>
            </v-row> -->
            <v-row style="background-color:#FFE5EE">
              <v-col cols="12">
                <div class="text-center font-weight-bold2">
                  <h2>{{ this.languageSelect.value === 0 ? 'POP MART CAFE' : 'POP MART CAFE'}}</h2>
                </div>
                <div class="text-center font-weight-cond ma-0 pa-0" style="line-height: 3vh;">
                  {{ this.languageSelect.value === 0 ? this.dataBookingData.dueDateTextDay : this.dataBookingData.dueDateTextDay}}
                  <br>
                  {{ this.languageSelect.value === 0 ? this.dataBookingData.timeSlot : this.dataBookingData.timeSlot}}
                  <br>
                  {{ this.languageSelect.value === 0 ? "จำนวน" : "SeatCount"}} {{ this.languageSelect.value === 0 ? this.dataBookingData.seatCount : this.dataBookingData.seatCount}} {{ this.languageSelect.value === 0 ? "ที่นั่ง" : "Seats"}}
                  <br>
                  {{ this.languageSelect.value === 0 ? "โต๊ะ" : "Table" }} {{ this.languageSelect.value === 0 ? this.dataBookingData.tables : this.dataBookingData.tables}}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="">
                <div class="d-flex justify-center">
                  <img :src="require('@/assets/Heart.png')" width="50%" height="50%" alt="avatar" />
              </div>
              </v-col>
              <v-col cols="12">
                <div class="text-center">
                  <qrcode-vue :value="qrMsg" :size="150" style="display: inline-block;line-height: 0;padding: 5px;background-color: white;border-radius: 15px;" />
                </div>
              </v-col>
            </v-row>
            <div class="d-flex justify-center align-center">
              <v-img
                v-if="!(this.dataBookingData.status == 'confirm'&&this.dataBookingData.remainingRoundCount > 0)"
                :src="require('@/assets/Lable_02.png')"
                :style="{ width: '100%', height: '10%' }"
                contain
              >
                <div
                  class="d-flex justify-center align-center"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; ;"
                >
                <span v-if="this.dataBookingData.status == 'confirm'">
                  <div v-if="this.dataBookingData.remainingRoundCount == 0 && this.dataBookingData.waitcall === false" class="text-center pa-1  font-weight-cond" >
                    {{ this.languageSelect.value === 0 ? "กรุณามาที่จุดรับคิว 15 นาที" : "Please come to the queue counter 15 minutes" }}<br>
                    {{ this.languageSelect.value === 0 ? "ก่อนถึงรอบของคุณลูกค้าด้วยนะคะ" : "before your appointment time." }}
                  </div>
                  <div v-if="this.dataBookingData.remainingRoundCount == 0 && this.dataBookingData.waitcall === true" class="text-center pa-1  font-weight-cond" >
                    {{ this.languageSelect.value === 0 ? "กรุณารอซักครู่" : "Please wait a moment." }}<br>
                    {{ this.languageSelect.value === 0 ? "พนักงานของเราจะให้บริการในเร็วๆนี้ค่ะ" : "Our staff will assist you shortly." }}
                  </div>
                  <div v-if="this.dataBookingData.remainingRoundCount < 0" class="text-center pa-1  font-weight-cond" >
                    {{ this.languageSelect.value === 0 ? "กรุณารอซักครู่" : "Please wait a moment." }}<br>
                    {{ this.languageSelect.value === 0 ? "พนักงานของเราจะให้บริการในเร็วๆนี้ค่ะ" : "Our staff will assist you shortly." }}
                  </div>
                </span>
                <div v-if="this.dataBookingData.status == 'confirmJob'" class="text-center pa-1  font-weight-cond" >
                    {{ this.languageSelect.value === 0 ? "ทานให้อร่อยนะคะ" : "Enjoy your meal." }}<br>
                </div>
                <div v-if="this.dataBookingData.status == 'closeJob'" class="text-center pa-1  font-weight-cond" >
                    {{ this.languageSelect.value === 0 ? "ขอบคุณที่แวะมาใช้บริการ POP Cafe" : "Thank you for visiting POP Cafe." }}<br>
                    {{ this.languageSelect.value === 0 ? "ไว้เจอกันใหม่นะคะ" : "Hope to see you again." }}
                </div>
                <div v-if="this.dataBookingData.status == 'cancel'" class="text-center pa-1  font-weight-cond" >
                    {{ this.languageSelect.value === 0 ? "ขออภัยค่ะ ทางเราไม่เห็นคุณลูกค้า" : "We're sorry, but we didn't see you" }}<br>
                    {{ this.languageSelect.value === 0 ? "มายืนยันตัวตนภายในเวลาที่กำหนด" : "check in within the allotted time," }}<br>
                    {{ this.languageSelect.value === 0 ? "จึงต้องขออนุญายกเลิกคิวนะคะ" : "so we have to cancel your queue." }}<br>
                </div>
                </div>
              </v-img>
            </div>
          </div>
        </div>
      </v-sheet>
      <!-- <v-sheet v-else>
      <div v-if="loading" class="text-center mt-6" :style="'background-color:'+ DarkModeBackground">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ this.languageSelect.value === 0 ? "ไม่มีข้อมูล" : "No data." }}</h5>
      </div>
    </v-sheet> -->
    </v-card>
    <v-dialog
      v-model="isDialogCancel"
      width="390"
      persistent
      scrollable
      content-class="custom-dialog"
      style="overflow-x: hidden !important;max-width: 100vw !important; box-sizing: border-box !important;border-radius: 0px !important"
    >
      <v-card style="overflow-x: hidden; max-width: 100%; box-sizing: border-box;">
        <v-card-text class="pa-3">
          <v-row>
            <v-col cols="12" class="text-center">
              <h4 class="text-text-green-h-q font-weight-cond" style="color: black;font-size: 36px !important;">
                {{ this.languageSelect.value === 0 ? "จะยกเลิกนัดหมายจริง ๆ หรอ ..." : "Are you sure you want to cancel the appointment...?" }}
              </h4>
            </v-col>

            <v-col cols="12" class="text-center pl-0 pr-0">
              <div class="d-flex justify-center">
                <v-avatar size="250" class="zoom-avatar" tile>
                  <img :src="require('@/assets/avatar_popmart.png')" alt="avatar" />
                </v-avatar>
              </div>
            </v-col>

            <v-col cols="12" class="text-center pl-0 pr-0">
              <h4 style="color: #8a8d93;font-size: 36px !important;" class="font-weight-cond" >
                {{ this.languageSelect.value === 0 ? "อยากรู้จังเลยว่าทำไมถึงต้องยกเลิก" : "May I ask why you need to cancel?" }}
              </h4>
            </v-col>
            <v-col cols="12" class="text-center pl-0 pr-0">
              <div class="d-flex justify-center flex-wrap">
                <v-chip
                  v-model="NoteComment"
                  v-for="(note) in Note"
                  :key="note.reason"
                  class="ma-1"
                  outlined
                  :color="selectedNote === note ? 'red' : ''"
                  style="color: #8a8d93"
                  @click="selectedNote = note"
                >
                  <font class="font-weight-cond" style="font-size: 28px !important;font-family: 'DB Helvethaica X 57' !important;">{{ languageSelect.value === 0 ? note.reason : note.reason_en }}</font>
                </v-chip>
              </div>
            </v-col>
            <v-col v-if="isboolNote" cols="12 pl-0 pr-0" class="text-center">
              <p style="color: red;">กรุณาเลือกเหตุผล</p>
            </v-col>
            <v-col cols="12" class="d-flex justify-center pl-0 pr-0">
              <v-btn
                rounded
                outlined
                large
                color="white"
                class="font-weight-cond mr-3"
                style="background-color: white; color: #8A8D93 !important; border: 1px solid #8A8D93;width: 160px;font-family: 'DB Helvethaica X 67' !important;"
                @click="isDialogCancel = false; selectedNote = null; isboolNote = false"
              >
              {{ this.languageSelect.value === 0 ? "ปิด" : "Close" }}
              </v-btn>

              <v-btn
                rounded
                large
                color="red"
                class="font-weight-cond"
                style="color:white;width: 160px;font-family: 'DB Helvethaica X 67' !important;"
                @click="cancelBooking"
              >
              {{ this.languageSelect.value === 0 ? "ยกเลิกนัดหมาย" : "Cancel Booking" }}
              </v-btn>
            </v-col>
            <v-col cols="12" class="">
                <div class="d-flex justify-center">
                  <img :src="require('@/assets/Heart.png')" width="50%" height="50%" alt="avatar" />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-footer padless fixed style="background-color: #ffffff00;">
    <v-row v-if="this.dataBookingData.status !== 'cancel' && this.dataBookingData.status !== 'closeJob'">
        <v-col cols="12" class="text-center mt-4" style="padding: 0;">
          <v-btn
            v-if="this.$route.query.shopId"
            elevation="0"
            style="background-color: #f44336; border: 2px solid #E60020; border-radius: 500px; color: white;"
            @click="isDialogCancel = true"
            class="font-weight-cond"
          >
            {{ this.languageSelect.value === 0 ? "ยกเลิกนัดหมาย" : "Cancel Booking" }}
          </v-btn>

        </v-col>
      </v-row>
      <v-col class="text-center" cols="12">
        <strong style="font-size: 18px !important;" class="font-weight-cond">{{ this.languageSelect.value === 0 ? "* ทางบริษัทขอสงวนสิทธิ์ในการข้ามคิวกรณีลูกค้าไม่แสดงตน" : "We may skip your turn if you don’t show up." }}</strong>
      </v-col>
    </v-footer>

  </v-main>
</template>

<script>
import axios from 'axios' // api
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
import io from 'socket.io-client'

export default {
  components: {
    name: '',
    QrcodeVue
  },
  data () {
    return {
      unsubscribe: null,
      loading: false,
      textCheckQueue: '',
      textCheckQueueEng: '',
      checkMemberId: '',
      value: '',
      size: 200,
      foreground: '#000000',
      profile: null,
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      dataBookingList: [],
      dataBooking: [],
      dataBookingData: [],
      dataBookingDataUse: [],
      sequenceNo: 0,
      shopId: this.$route.query.shopId,
      bookNo: this.$route.query.bookNo,
      beforQueue: '',
      checkQueue: null,
      dataLineConfig: {},
      showTime: '',
      source: '',
      userId: '',
      forwardQueue: false,
      isDialogCancel: false,
      Note: [
        {
          reason: 'รอนานเกินไป',
          reason_en: 'Waited too long'
        },
        {
          reason: 'ไปไม่ทัน',
          reason_en: 'Unable to make it in time'
        },
        {
          reason: 'จองผิด',
          reason_en: 'Booked by mistake'
        },
        {
          reason: 'เหตุผลส่วนตัว',
          reason_en: 'Personal reasons'
        }
      ],
      selectedNote: null,
      NoteComment: null,
      isboolNote: false,
      qrMsg: '',
      languageSelect: {
        value: 0,
        text: 'TH',
        flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg'
      },
      languageOptions: [
        {
          value: 0,
          text: 'TH',
          flag: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e'
        },
        {
          value: 1,
          text: 'EN',
          flag: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b'
        }
      ],
      menu: false,
      socket: null
    }
  },
  computed: {
    isVForCompleted () {
      return this.dataBookingDataUse.length === 0
    }
  },
  created () {
    // this.getFirestore()
  },
  beforeDestroy () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  async mounted () {
    document.body.style.overflow = 'auto'
    // this.DNS_IP = 'https://pretest-api.betaskthai.com'
    this.loading = true
    try {
      if (this.$route.query.forwardQueue === 'true') {
        this.forwardQueue = true
      }
      if (this.$route.query.languageSelect) {
        this.languageSelect.value = parseInt(this.$route.query.languageSelect)
      } else {
        this.languageSelect.value = 0
      }
      if (this.$route.query.shopId) {
        if (this.$route.query.checkLine) {

        } else {
          let checkShopId = ''
          if (this.$route.query.shopId) {
            checkShopId = this.$route.query.shopId
          } else {
            const queryString = decodeURIComponent(window.location.search).replace(
              '?liff.state=',
              ''
            )
            console.log('queryString', queryString)
            const params = new URLSearchParams(queryString)
            checkShopId = params.get('shopId')
          }

          this.dataLineConfig = await this.getDataLineConfig(checkShopId)
          await this.checkLiffLogin(this.dataLineConfig, false)
        }
        if (!this.$route.query.bookNo) {
          await this.getBookingNo()
        }
        await this.getBookingField()
        await this.getShop()
        await this.getBookingData()
        await this.getBookingDataUse()
        await this.setqrurl()
        // this.initSocket()
      } else {
        this.$swal(
          'พบความผิดพลาดระหว่างดำเนินการ',
          'กรุณาติดต่อเจ้าหน้าที่',
          'info'
        )
      }
    } catch (error) {

    } finally {
      this.loading = false
    }
  },
  methods: {
    async setqrurl () {
      this.dataLineConfig = await this.getDataLineConfig(this.shopId)
      this.qrMsg = 'https://liff.line.me/' + this.dataLineConfig.liffMainID + '/CheckQueueStoreFrontPopMart?bookNo=' + this.bookNo + '&shopId=' + this.shopId
    },
    async getBookingField () {
      this.showTime = ''
      await axios
        .get(this.DNS_IP + '/BookingField/get?shopId=' + this.shopId)
        .then(async response => {
          let rs = response.data
          if (rs.status === false) {
            this.showTime = 'แสดง'
          } else {
            this.showTime = rs[0].showTime || 'แสดง'
          }
        })
    },
    async initSocket () {
      this.socket = io('https://belinked-ws.betaskthai.com/', { transports: ['websocket'] })
      this.socket.on('connect', () => {
        console.log('🟢 Connected', this.socket.id)
      })
      this.socket.on('disconnect', () => {
        console.log('🔴 Disconnected')
      })
      this.socket.on('cancel_success', msg => {
        console.log('📨', msg)
        this.getBookingData(false)
      })
      this.socket.on('connect_error', err => {
        console.error('❌ connect_error', err)
      })
    },
    async cancelBooking () {
      if (!this.selectedNote) {
        this.isboolNote = true
      } else {
        let body = {
          bookNo: this.bookNo,
          shopId: this.$route.query.shopId,
          CREATE_USER: this.profile.userId, // line user id
          LAST_USER: this.profile.userId, // line user id
          remarkRemove: this.selectedNote.reason // เหมือนในรูป
        }
        console.log('body', body)
        await axios
          .post(this.DNS_IP + '/pop_mart/cancel_booking', body)
          .then(async response => {
            this.$liff.closeWindow()
            console.log('response', response)
            // let rs = response.data
            // if (rs.status === false) {
            //   this.showTime = 'แสดง'
            // } else {
            //   this.showTime = rs[0].showTime || 'แสดง'
            // }
          })
      }
    },
    async checkLiffLogin (dataLineConfig, isFlex) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile(isFlex)
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile (isFlex) {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
          // if (_this.$route.query.source === 'ohrich') {
          // _this.checkMemberOhrich(isFlex)
          // }
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getShop () {
      if (this.$route.query.shopId) {
        await axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.$route.query.shopId).then(response => {
          let rs = response.data
          if (rs.length > 0) {
            this.shop = rs
            console.log('this.shop', this.shop)
            rs.forEach(v => {
              if (v.primaryColor) {
                this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                this.DarkModeBackground = v.primaryColor
                this.DarkModeButton = v.secondaryColor
              } else {
                this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                this.DarkModeBackground = '#FFFFFF'
                this.DarkModeButton = '#E1F3FF'
              }
              if (v.shopImge) {
                this.LoGo = v.shopImge
              } else {
                this.LoGo = require('@/assets/Thank.svg')
              }
              if (v.shopImageCover) {
                this.ImgCover = v.shopImageCover
              } else {
                if (v.category === 'ธุรกิจรถยนต์') {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                } else {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                }
              }
              if (v.darkMode === 'True') {
                this.DarkMode = '#FFFFFF'
                this.DarkModefont = '#FFFFFF'
              } else {
                this.DarkMode = ''
                this.DarkModefont = '#173053'
              }
            })
            this.bookingthankText = rs[0].bookingthankText
            console.log('this.bookingthankText', this.bookingthankText)
          } else {
            this.shop = null
          }
        })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.LoGo = require('@/assets/Thank.svg')
        this.DarkMode = ''
        this.DarkModefont = '#173053'
      }
    },
    async getBookingQueue () {
      let url = ''
      if (this.forwardQueue) {
        url = this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&dueDate=' + this.dataBookingData[0].dueDateDay + '&masBranchID=' + this.dataBookingData[0].masBranchID + '&flowId=' + this.dataBookingData[0].flowId + '&storeFrontQueue=is not null&statusBt=confirmJob'
      } else {
        url = this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&dueDate=' + this.dataBookingData[0].dueDateDay + '&masBranchID=' + this.dataBookingData[0].masBranchID + '&flowId=' + this.dataBookingData[0].flowId + '&storeFrontQueue=is not null&statusBt=confirm'
      }
      await axios
        .get(url)
        .then(async response => {
          let rs = response.data
          console.log('test', rs)
          if (rs.length > 0) {
            let dataFilterForwardQueue = []
            if (this.forwardQueue) {
              dataFilterForwardQueue = rs.filter(el => { return el.forwardQueueId === this.dataBookingData[0].forwardQueueId })
            } else {
              dataFilterForwardQueue = rs
            }
            if (dataFilterForwardQueue.filter((item, key) => item.storeFrontQueue === this.dataBookingData[0].storeFrontQueue).length > 0) {
              let findIndex = dataFilterForwardQueue.findIndex((item, key) => item.storeFrontQueue === this.dataBookingData[0].storeFrontQueue)
              console.log('findIndex', findIndex)
              this.beforQueue = dataFilterForwardQueue.filter((item, key) => key < findIndex).length
              console.log('this.beforQueue', this.beforQueue)
              this.checkQueue = this.dataBookingData[0].storeFrontQueue
            } else {
              this.checkQueue = 0
              console.log('this.beforQueue', this.beforQueue)
            }
          } else {
            this.checkQueue = 0
          }
        })
    },
    async getBookingData (bool = true) {
      // let dataBookingData = []
      let url = this.DNS_IP + '/pop_mart/get-my-queue/' + this.bookNo
      if (!this.bookNo) {
        url = this.DNS_IP + '/get-my-queue-member/' + this.profile.userId
      }
      await axios
        .get(url)
        .then(async response => {
          let rs = response.data
          console.log('rs', rs)
          if (rs.ok) {
            this.dataBookingData = rs.data
            if (moment(moment().format('HH:mm'), 'HH:mm').isAfter(moment(this.dataBookingData.timeSlot, 'HH:mm')) && this.dataBookingData.status === 'confirm') {
              this.dataBookingData.waitcall = true
            } else {
              this.dataBookingData.waitcall = false
            }
            let BodyCheckMember = {
              name: this.profile.displayName,
              picture: this.profile.pictureUrl,
              lineUserId: this.profile.userId
            }
            console.log(BodyCheckMember)
            if (bool) {
              await axios
                .post(this.DNS_IP + '/pop_mart/check_member/' + this.bookNo, BodyCheckMember)
                .then(async response => {
                }).catch(err => {
                  console.log(err.code, err.message)
                })
            }
          }
        }).catch(err => {
          console.log(err.code, err.message)
        })
    },
    async getBookingDataUse () {
      this.dataBookingDataUse = []
      await axios
        .get(this.DNS_IP + '/BookingData/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        // .get(this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.dataBookingDataUse = rs
          }
        })
    },
    async getBookingNo () {
      this.dataBookingDataUse = []
      await axios
        .get(this.DNS_IP + '/pop_mart/get-my-queue-member/' + this.profile.userId)
        // .get(this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        .then(async response => {
          let rs = response.data
          console.log('getBookingNo', rs)
          this.bookNo = rs.data.bookNo
        })
    },
    async checkMember (bookNo) {
      await axios.get(this.DNS_IP + '/booking_view/get?bookNo=' + bookNo)
        .then(async (response) => {
          let rs = response.data
          console.log('RSTESTTTTTT', response)
          if (rs[0].lineUserId === null || rs[0].lineUserId === '') {
            this.checkMemberId = 'memberNo'
          } else {
            this.checkMemberId = 'memberTrue'
          }
          console.log('this.checkMemberId', this.checkMemberId)
        }).catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    async getBotinfo () {
      console.log('getBotinfo')
      if (this.$route.query.source === 'ohrich') {
        this.dataLineConfig = await this.getDataLineConfig(this.$route.query.shopId)
        await this.checkLiffLogin(this.dataLineConfig, true)
      } else {
        if (this.$route.query.shopId) {
          const url = `${this.DNS_IP}/line/getOa`
          // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
          const config = {
            headers: {
              'botId': this.$route.query.shopId
            }
          }
          await this.checkMember(this.bookNo)
          await axios.get(url, config).then((response) => {
            let rs = response.data
            console.log('rs1111', rs)
            if (this.checkMemberId === 'memberNo') {
              // window.location.href = 'https://line.me/R/oaMessage/' + rs.basicId + `?เปิดรับการแจ้งเตือน ` + this.profile.userId
              window.location.href = 'https://line.me/R/oaMessage/' + rs.basicId + `/?เปิดรับการแจ้งเตือน`
              // liff.openliff.openWindow({
              //   url: 'https://line.me/R/oaMessage/' + rs.basicId + `?เปิดรับการแจ้งเตือน`,
              //   external: true
              // })
            } else {
              window.location.href = 'line://ti/p/' + rs.basicId
            }
          })
        }
      }
    },
    async checkMemberOhrich (isFlex) {
      await this.saveUserId()
      await axios.get(this.DNS_IP + '/member/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId).then(async result => {
        var lineUserIds = ''
        var liffUserIds = ''
        if (result.data.status === false) {
          await this.onSubmit()
        } else {
          lineUserIds = result.data[0].lineUserId || ''
          liffUserIds = result.data[0].liffUserId || ''
          if (lineUserIds === '' && liffUserIds !== '') {
            await this.onUpdate(result.data[0].memberId)
          }
        }
        if (isFlex) {
          let dttt = {
            checkGetQueue: 'False',
            firstSend: 'True'
          }
          await axios
            .post(this.DNS_IP + '/Booking/pushMsgQueue/' + this.bookNo, dttt)
            .then(async response => { }).catch(error => {
              console.log('error function pushMsgQueue : ', error)
            }).catch(error => {
              console.log('error function pushMsgQueue : ', error)
            })
        }
      }).catch(error => {
        console.log('error function member get : ', error)
      })
    },
    async saveUserId () {
      let userId = {
        'userId': this.profile.userId
      }
      await axios.post(this.DNS_IP + '/Booking/edit/' + this.bookNo, userId).then(async response => {
        console.log('response', response)
      }).catch(error => {
        console.log('error function saveUserId : ', error)
      })
    },
    async onSubmit () {
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        lineUserId: this.profile.userId,
        shopId: this.$route.query.shopId,
        memberId: idMember,
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity('post', `/member/add`, params)
      console.log('result', result.status)
    },
    async onUpdate (idMember) {
      // "https://api-belinked.betaskthai.com/member/editWebhook/" + request.body.events[0].message.text.split(" ")[2]
      // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
      // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
      const params = {
        lineUserId: this.profile.userId,
        liffUserId: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity('post', '/member/editWebhook/' + idMember, params)
      console.log('result', result.status)
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.log(error)
        result = null
      })
      return result
    },
    onLanguageSelect (locale) {
      this.languageSelect = locale
    },
    async getBotinfoChatAuto () {
      console.log('getBotinfoChatAuto')

      if (this.$route.query.shopId) {
        const url = `${this.DNS_IP}/line/getOa`
        // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
        const config = {
          headers: {
            'botId': this.$route.query.shopId
          }
        }
        await axios.get(url, config).then((response) => {
          let rs = response.data
          window.location.href = 'line://ti/p/' + rs.basicId
        })
      }
    }
    // async getFirestore () {
    //   try {
    //     console.log('getFirestore -> ', this.unsubscribe)
    //     if (this.unsubscribe) {
    //       this.unsubscribe()
    //     }
    //     this.firestore = this.$firebase.firestore()
    //     this.unsubscribe = this.firestore.collection(`QueueOnline/shopId/${this.shopId}`).doc(this.bookNo)
    //       .onSnapshot(async (snapshot) => {
    //         if (!snapshot.exists) {
    //           await this.updateProcessWebNew()
    //         } else {
    //           console.log('getFirestore -> data', snapshot.data())
    //           if (snapshot.data().active === '1') {
    //             console.log('active [start] is updateProcessShopUpdate')
    //             await this.updateProcessShopUpdate()
    //             console.log('active [end] is updateProcessShopUpdate')
    //             console.log('snapshot data -> active is 1')
    //             console.log('active [start] is get booking')
    //             await this.getBookingData()
    //             console.log('active [end] is get booking')
    //           } else {
    //             console.log('snapshot data -> active is 0')
    //           }
    //         }
    //       })
    //   } catch (error) {
    //     console.log('Error getFirestore', error)
    //   }
    // },
    // async updateProcessWebNew  () { // active = 1
    //   try {
    //     let body = {
    //       userName: this.bookNo,
    //       shopId: this.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-CreateProcessNew', body)
    //   } catch (error) {
    //     console.log('updateProcessWebNew error-> ', error)
    //   }
    // },
    // async updateProcessShopUpdate  () { // active = 0
    //   try {
    //     let body = {
    //       userName: this.bookNo,
    //       shopId: this.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-ProcessUseNew', body)
    //   } catch (error) {
    //     console.log('updateProcessShopUpdate error-> ', error)
    //   }
    // }
  }
}
</script>

<style scoped>
/* @font-face {
  font-family: 'DB Helvethaica X Bd';
  src: url('~@/assets/DB Helvethaica X Bd v3.2_3.ttf') format('truetype');
  font-style: normal;
} */
@font-face {
  font-family: 'DB Helvethaica X Bd';
  src: url('~@/assets/DB Helvethaica X Bd v3.2_2.ttf') format('truetype');
  /* font-weight: bold; */
  font-style: normal;
}
@font-face {
  font-family: 'DB Helvethaica X Bd Cond';
  src: url('~@/assets/DB Helvethaica X Bd Cond v3.2_2.ttf') format('truetype');
  /* font-weight: bold; */
  font-style: normal;
}
@font-face {
  font-family: 'DINPro-Black';
  src: url('~@/assets/dinpro_black.otf') format('opentype');
  /* font-weight: bold; */
  font-style: normal;
}
@font-face {
  font-family: 'DB Helvethaica X 57';
  src: url('~@/assets/DB Helvethaica X Cond v3.2_2.ttf') format('truetype');
  /* font-weight: bold; */
  font-style: normal;
}
@font-face {
  font-family: 'DB Helvethaica X 67';
  src: url('~@/assets/DB Helvethaica X Med Cond v3.2_2.ttf') format('truetype');
  /* font-weight: bold; */
  font-style: normal;
}
*, .v-application {
  font-family: 'DB Helvethaica X Bd' !important;
  /* font-size: 18pt !important; */
}
.myqueue {
  font-family: 'DINPro-Black' !important;
  font-size: 48px !important;
  font-weight: bold;
}
.font-weight-bold2 {
  font-size: 24px !important;
}
.font-weight-cond {
  font-family: 'DB Helvethaica X Bd Cond' !important;
  font-size: 24px !important;
}
.main {
  background-color: #e60a21;
  height: 100vh;
}
.content {
  overflow: auto;
  white-space: normal;
}

.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
.custom-dialog {
  max-height: unset !important; /* ปิด max-height เดิมของ Vuetify */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 0 !important;
}
.zoom-avatar {
  overflow: hidden; /* ซ่อนส่วนเกินของรูป */
}
.zoomed-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 275%; /* ซูมภาพ */
  height: 150%;
  transform: translate(-45%, -50%); /* -50% คือให้อยู่ตรงกลาง, -40% เลื่อนภาพไปทางขวา */
  object-fit: cover;
}
@media (max-height: 600px) {
  .custom-dialog {
    max-height: 90vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/CheckQueueStoreFrontPopMart.vue